import LoadingDots from "@components/LoadingDots";
import { images } from "@img/imagesMap";
import * as excel from "@script/excel";
import { useState } from "react";
import ExcelUploadTemplate from "./ExcelUploadTemplate";

export default function MgmtMworksTab_member() {
  const [excelFileName, setExcelFileName] = useState<string>();
  const [excelDataMworks, setExcelDataMworks] = useState<any | null>(null);

  const [isUpload, setIsUpload] = useState(false);

  async function handleFileUpload(file: File) {
    setExcelDataMworks(null);

    setIsUpload(true);
    // 파일 유효성 검사
    if (file.size > 10 * 1024 * 1024) {
      alert("❌ 파일 크기는 10MB를 초과할 수 없습니다.");
      setIsUpload(false);
      return;
    }

    if (
      !file.name.toLowerCase().endsWith(".xlsx") &&
      !file.name.toLowerCase().endsWith(".xls")
    ) {
      alert("❌ 지원되지 않는 파일 형식입니다. (.xlsx, .xls만 지원)");
      setIsUpload(false);
      return;
    }
    setExcelFileName(file.name);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const uploadResult = await excel.upload_mworks_member(formData);
      setExcelDataMworks(uploadResult);
    } catch (error) {
      setExcelDataMworks({ result: "serverError" });
    } finally {
      setIsUpload(false);
    }
  }
  return (
    <ExcelUploadTemplate
      title="직원 등록"
      templateUrl="/template/easysetting_member.xls"
      templateFileName="직원등록_템플릿.xls"
      onFileUpload={handleFileUpload}
      isUpload={isUpload}
      excelFileName={excelFileName}
    >
      {excelDataMworks && (
        <div className="mgmtMworks_uploadResult">
          {Array.isArray(excelDataMworks) ? (
            <>
              <div className="mgmtMworks_uploadResult_message mgmtMworks_uploadResult_message--error">
                업로드 오류가 있습니다.
              </div>
              <table className="mgmtMworks_uploadError_table">
                <tbody>
                  {excelDataMworks.map((item, idx) => (
                    <tr key={idx}>
                      <td className="mgmtMworks_uploadError_td">{item.num}</td>
                      <td className="mgmtMworks_uploadError_td">{item.EmpNum}</td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.MemberID}
                      </td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.EmployeeName}
                      </td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.Birthday}
                      </td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.JoinDate}
                      </td>
                      <td className="mgmtMworks_uploadError_td">{item.Tel}</td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.PortableTel}
                      </td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.Ck_Email}
                      </td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.Manager}
                      </td>
                      <td className="mgmtMworks_uploadError_td">{item.Depth1}</td>
                      <td className="mgmtMworks_uploadError_td">{item.Depth2}</td>
                      <td className="mgmtMworks_uploadError_td">{item.Depth3}</td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.position}
                      </td>
                      <td className="mgmtMworks_uploadError_td">{item.duty}</td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.nightkeep}
                      </td>

                      {/* ● errorType 표시 */}
                      <td className="mgmtMworks_uploadError_td mgmtMworks_uploadError_td--label">
                        {item.errorType}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          ) : excelDataMworks.result === "succeed" ? (
            <div className="mgmtMworks_uploadResult_message mgmtMworks_uploadResult_message--ok">
              업로드가 완료되었습니다
            </div>
          ) : (
            <div className="mgmtMworks_uploadResult_message mgmtMworks_uploadResult_message--error">
              업로드에 실패하였습니다.11
            </div>
          )}
        </div>
      )}
    </ExcelUploadTemplate>
  );
}